import { render, staticRenderFns } from "./MusicMap.vue?vue&type=template&id=482d337c&"
import script from "./MusicMap.vue?vue&type=script&lang=js&"
export * from "./MusicMap.vue?vue&type=script&lang=js&"
import style0 from "./MusicMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports